import axios from './axiosConfig';

const API_URL = '/groups/';

const createGroup = async (data) => { // OK
    return await axios.post(API_URL + 'create', data);
};

const getGroupsByStage = async (stageId) => { // OK
    return await axios.get(API_URL + 'by-stage/' + stageId);
};

const deleteGroup = async (groupId) => { // OK
    return await axios.delete(API_URL + groupId);
};

const addPlayerToGroup = async (groupId, playerId) => { // OK
    return await axios.post(API_URL + 'add-player', { groupId, playerId });
};

const getPlayersByGroup = async (groupId) => { // OK
    return await axios.get(API_URL + groupId + '/players');
};

const removePlayerFromGroup = async (groupId, playerId) => { // OK
    return await axios.delete(API_URL + groupId + '/players/' + playerId);
};

const getUserGroupId = async (userId) => {
    try{
        const response = await axios.get(API_URL + 'user-group/' + userId);
        return response.data.groupId;
    } catch(error){
        console.error('Erro ao obter o ID do grupo do usuário:', error);
        throw error;
    }
};

const getPlayerHistoryByStage = async (stageId, groupId) => {
    return await axios.get(API_URL + 'player-history/' + stageId + '/' + groupId);
};

const updateGroupsOrder = async (orderList) => {
    return await axios.put(API_URL + 'groups/order', {groups: orderList});
};

export default {
    createGroup,
    getGroupsByStage,
    deleteGroup,
    addPlayerToGroup,
    getPlayersByGroup,
    removePlayerFromGroup,
    getUserGroupId,
    getPlayerHistoryByStage,
    updateGroupsOrder,
};
